export default __webpack_public_path__ + "static/media/phone.d1bfb2a2.svg";